import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { getCompromissoTypeLabel } from '../Blocks/PersonAgenda/components/personAgendaMessages';
import { getCategoryStyle } from '../Blocks/PersonAgenda/utils';
import { formatHoraBrasilia } from '../Blocks/PersonAgenda/utilsTimezone';

import styles from './AgendaInfoCard.module.less';

const messages = defineMessages({
  timeLabel: {
    id: 'Time',
    defaultMessage: 'Time',
  },
  locationLabel: {
    id: 'Location',
    defaultMessage: 'Location',
  },
  openAppointment: {
    id: 'Open appointment: {title}',
    defaultMessage: 'Open appointment: {title}',
  },
});

const AgendaInfoCard = ({ appointment, isEditMode }) => {
  const intl = useIntl();
  const categoryStyle = getCategoryStyle(appointment?.category);
  const title = appointment?.title || '';
  const location = appointment?.location || '';
  const eventPath = flattenToAppURL(appointment?.link || '');
  const time = formatHoraBrasilia(appointment?.start);
  const typeLabel = getCompromissoTypeLabel(
    appointment?.category,
    intl,
    appointment?.categoryTitle || '',
  );

  return (
    <ConditionalLink
      condition={!isEditMode}
      className={cx('br-card mb-2 rounder-lg', styles.card)}
      href={eventPath || undefined}
      aria-label={intl.formatMessage(messages.openAppointment, { title })}
    >
      <MaybeWrap
        as={'a'}
        condition={isEditMode}
        className={cx('br-card mb-2 rounder-lg', styles.card)}
      >
        <div
          className={cx(
            'card-content rounder-lg p-3 bg-pure-0 d-flex flex-column gap-2 justify-content-between',
            styles.cardContent,
          )}
        >
          <div className="mb-2">
            <h3
              className={cx('m-0 mb-2 text-up-01', styles.title)}
              title={title}
            >
              {title}
            </h3>
          </div>

          <div className="d-flex flex-column gap-1 text-down-01 text-gray-80">
            <div className="d-flex align-items-start">
              <i className="far fa-clock" aria-hidden="true" />
              <span className="ml-1">{time}</span>
            </div>

            {location ? (
              <div className="d-flex align-items-start">
                <i className="fas fa-map-marker-alt" aria-hidden="true" />
                <span className="ml-1">{location}</span>
              </div>
            ) : null}

            {typeLabel ? (
              <div className="pb-2">
                <span
                  className="br-tag small text-down-01"
                  style={{
                    backgroundColor: categoryStyle.backgroundColor || 'inherit',
                    color: categoryStyle.textColor || 'inherit',
                  }}
                >
                  {typeLabel}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </MaybeWrap>
    </ConditionalLink>
  );
};

AgendaInfoCard.propTypes = {
  appointment: PropTypes.shape({
    category: PropTypes.string,
    categoryTitle: PropTypes.string,
    link: PropTypes.string,
    location: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    title: PropTypes.string,
  }).isRequired,
  isEditMode: PropTypes.bool,
};

export default AgendaInfoCard;
